import React from 'react'
import styled from 'styled-components'
import { Wrap, LargeCentered } from '@/styles/Layout'

const Container = styled(Wrap)`
  background: black;
`

const Proportional = styled(LargeCentered)`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  z-index: 20;
  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`
const Embed = ({ iframe }) => {
  return (
    <Container>
      <Proportional dangerouslySetInnerHTML={{ __html: iframe }}></Proportional>
    </Container>
  )
}

export default Embed
